import { IonBadge, IonCol, IonGrid, IonIcon, IonRippleEffect, IonRow, IonText } from '@ionic/react';
import { buildOutline, playCircle, playSkipForwardCircle, stopCircle } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { getClockingId, getJobId } from '../../../common/util';
import { ClockingDirection } from '../../../models/dms/clocking.model';
import { IRepairOrderJob } from '../../../models/dms/repairOrderJob.model';
import { useAppSelector } from '../../../store/hooks';
import LabourTimer from '../../labourTimer/LabourTimer';
import { IonCardWrapper } from './JobCard.styles';

interface IComponentProps {
  job: IRepairOrderJob;
  onClick: (e: React.MouseEvent, repairOrder: IRepairOrderJob) => void;
}

const JobCard: React.FC<IComponentProps> = ({ job, onClick }) => {
  const [thisJobTypeCodeRo, setThisJobTypeCodeRo] = useState('');
  const [selectedJobTypeCodeRo, setSelectedJobTypeCodeRo] = useState('');
  const [status, setStatus] = useState('');

  const { labourClocking } = useAppSelector((state) => state.technicianClocking);

  useEffect(() => {
    setThisJobTypeCodeRo(getJobId(job));
    if (labourClocking?.direction === ClockingDirection.On || labourClocking?.direction === ClockingDirection.Break) {
      const clockingId = getClockingId(labourClocking);
      setSelectedJobTypeCodeRo(clockingId);
    } else {
      setSelectedJobTypeCodeRo('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [labourClocking]);

  useEffect(() => {
    if (job.isInvoiced) {
      setStatus('INVOICED');
    } else {
      setStatus('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [job]);

  return (
    <IonCardWrapper className="ion-activatable ripple-card small flexed-fill-auto" onClick={(e) => onClick(e, job)} color={thisJobTypeCodeRo === selectedJobTypeCodeRo ? 'light' : ''}>
      <IonRippleEffect type="bounded" />

      {status && <div className="disable-card"></div>}
      {status && (
        <div className="flexed status-label">
          <IonBadge color="tertiary" slot="end">
            {status}
          </IonBadge>
        </div>
      )}
      {status}
      <IonGrid>
        <IonRow>
          <IonCol size="10">
            <IonGrid>
              <IonRow>
                <IonCol size="12">
                  <div className="ion-text-nowrap flexed flexed-center">
                    <IonIcon icon={buildOutline} size="large" className="title-icon" />
                    <IonText>
                      {job.jobType} / {job.jobCode}
                    </IonText>
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
            <IonText>{job.detailLine}</IonText>
          </IonCol>
          <IonCol size="2" className="ion-text-right flexed flexed-center ion-justify-content-end">
            <IonRow>
              <IonCol size="12" className="flexed col">
                {thisJobTypeCodeRo === selectedJobTypeCodeRo && <LabourTimer showSeconds={false} />}
                {thisJobTypeCodeRo !== selectedJobTypeCodeRo && !status && <IonIcon icon={playCircle} size="large" color="success" className="ion-align-self-center" />}
                {thisJobTypeCodeRo === selectedJobTypeCodeRo && labourClocking?.direction === ClockingDirection.Break && <IonIcon icon={playSkipForwardCircle} size="large" color="warning" className="ion-align-self-center" />}
                {thisJobTypeCodeRo === selectedJobTypeCodeRo && labourClocking?.direction === ClockingDirection.On && <IonIcon icon={stopCircle} size="large" color="danger" className="ion-align-self-center" />}
              </IonCol>
            </IonRow>
          </IonCol>
        </IonRow>
      </IonGrid>
    </IonCardWrapper>
  );
};

export default JobCard;
